import React from "react";

import useCurrentUser from "@editor/hooks/useCurrentUser";

import WorkspaceProvider from "../WorkspaceProvider";
import Onboarding from "./Onboarding";

const WorkspaceWrappedOnboarding: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { user } = useCurrentUser();

  return (
    <WorkspaceProvider
      workspaceId={user?.workspace?.id}
      saveWorkspaceIdAsLastVisited
    >
      <Onboarding>{children}</Onboarding>
    </WorkspaceProvider>
  );
};

export default WorkspaceWrappedOnboarding;
